"use client"

const DashboardWidgets = ({
  top_performing_destinations = [],
  top_n_recent_sales = []
}) => {

  return (
    <div
      style={{
        display: "grid",
        gridTemplateColumns: "1fr 1fr",
        gap: "20px",
        marginBottom: "24px"
      }}
    >
      {/* Top Performing Destinations */}
      <div
        style={{
          background: "#fff",
          borderRadius: "12px",
          padding: "20px",
          boxShadow: "0 2px 10px rgba(0,0,0,0.08)"
        }}
      >
        <h4
          style={{
            margin: "0 0 16px 0",
            fontSize: "16px",
            fontWeight: "700",
            color: "#B9366D"
          }}
        >
          Top Performing Destinations
        </h4>

        <div style={{ maxHeight: "200px", overflowY: "auto" }}>
          {top_performing_destinations.map((item, index) => (
            <div
              key={item.destination_store_name}
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                padding: "8px 0",
                borderBottom:
                  index < top_performing_destinations.length - 1
                    ? "1px solid #f0f0f0"
                    : "none"
              }}
            >
              <div>
                <div
                  style={{
                    fontSize: "14px",
                    fontWeight: "600",
                    color: "#333"
                  }}
                >
                  {item.destination_store_name}
                </div>
                <div style={{ fontSize: "12px", color: "#666" }}>
                  {item.transactions.toLocaleString()} transactions
                </div>
              </div>

              <div style={{ textAlign: "right" }}>
                <div
                  style={{
                    fontSize: "14px",
                    fontWeight: "700",
                    color: "#B9366D"
                  }}
                >
                  {item.total_units.toLocaleString()}
                </div>
                <div style={{ fontSize: "12px", color: "#666" }}>
                  units
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Top 10 Recent Sales */}
      <div
        style={{
          background: "#fff",
          borderRadius: "12px",
          padding: "20px",
          boxShadow: "0 2px 10px rgba(0,0,0,0.08)"
        }}
      >
        <h4
          style={{
            margin: "0 0 16px 0",
            fontSize: "16px",
            fontWeight: "700",
            color: "#B9366D"
          }}
        >
          Top 10 Recent Sales
        </h4>

        <div style={{ maxHeight: "200px", overflowY: "auto" }}>
          {top_n_recent_sales.slice(0, 10).map((item, index) => (
            <div
              key={index}
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                padding: "6px 0",
                borderBottom:
                  index < top_n_recent_sales.length - 1
                    ? "1px solid #f0f0f0"
                    : "none"
              }}
            >
              <div style={{ flex: 1 }}>
                <div
                  style={{
                    fontSize: "13px",
                    fontWeight: "600",
                    color: "#333"
                  }}
                >
                  {item.sku_code}
                </div>

                <div style={{ fontSize: "11px", color: "#666" }}>
                  {item.destination_store_name} • {item.month}
                </div>
              </div>

              <div
                style={{
                  background: "#f8f9fa",
                  borderRadius: "12px",
                  padding: "4px 8px",
                  fontSize: "14px",
                  fontWeight: "700",
                  color: "#B9366D"
                }}
              >
                {item.sale_quantity.toLocaleString()}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}

export default DashboardWidgets
